export const triangleWidth = 65;
export const triangleHeight = 2 * (triangleWidth / Math.sqrt(3));
